import ActionPanel from '@/components/ActionPanel';
import { BaseErrorModel, BaseResponseModel } from '@/models/core.model';
import { checkActivitiesEmptyCountry } from '@/services/activity-info.service';
import { toastErrorMessage, toastSuccessMessage } from '@/utils/toasterMessage';
import { AxiosError } from 'axios';
import React, { useState } from 'react';
import { Button, Message, useToaster } from 'rsuite';


const CheckActivitiesEmptyCountryAction: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const toaster = useToaster();

  const handleAction = () => {
    const handleYesClick = async () => {
      setLoading(true);
      try {
        const result: BaseResponseModel<number> = await checkActivitiesEmptyCountry();
        if (result.success) {
          toastSuccessMessage( `Empty country activities checked successfully. Total affected activities: ${result.result}`);
        }
      } catch (err) {
        const errorModel = (err as AxiosError<BaseErrorModel>).response?.data;
        toastErrorMessage(`Error checking activities missing country:${errorModel?.errorMessage}`);
      }
      finally {
        setLoading(false);
        toaster.clear(); 
      }
    };

    const handleNoClick = () => {
      toaster.clear(); 
    };

    toaster.push(
      <Message closable>
        <p style={{marginBottom:10}}>Are you sure you want to check activities missing country?</p>
        <div>
          <Button appearance="primary" onClick={handleYesClick}>Yes</Button>
          <Button appearance="subtle" onClick={handleNoClick} style={{ marginLeft:10}}>No</Button>
        </div>
      </Message>,
      { placement: 'topCenter', duration: 0 }
    );

  };


    return (
      <ActionPanel
        title='Check Activities Empty Country'
        description='This action will check for activities that are missing country information and attempt to update them based on available data.'
        onClick={handleAction}
        loading={loading}
      />
    );
};

export default CheckActivitiesEmptyCountryAction;
